import React, {useEffect} from 'react';
import {Button, Card, Divider, Spin} from 'antd';
import {Link, useNavigate} from "react-router-dom";
import {lockOnAcademy} from "@/lib/services/academyService";
import {URLS} from "@/lib/urls";
import {useApiSearchAcademies, useApiSearchAcademiesOld} from "@/api/academy";
import {sprintf} from "@/lib/utils/sprintf";
import toFaNumber from "@/lib/utils/number";
import TableSearch from "@/components/table/tableSearch";
import {oldDomain} from "@/constants/config";
import RenderIf from "@/components/render-if";
import GatewayAcademyCardSection from "@/pages/gateway/_section/GatewayAcademyCardSection";
import {getSubdomainFromUrl} from "@/lib/helper/urlSubdomain";

const GatewaySelectorPage = () => {

    const mySubdomain = getSubdomainFromUrl()

    const {data: AcademyList, isSuccess, isPending} = useApiSearchAcademiesOld({subdomain: mySubdomain})

    const navigate = useNavigate();


    function setSelectedAcademy(academyData, module) {
        switch (module) {

            // case "teacher":
            //     window.location.href = oldDomain('t')
            //     return;


            case "old-admin":
                window.location.href = oldDomain('m')
                return;

        }

        lockOnAcademy(academyData)

        if (module === "student" && (
            academyData?.user_academies?.children?.length > 0 ||
            academyData?.user_academies?.parent
        )) {
            navigate(URLS.gateway.selectChildren)
        } else {
            navigate('/' + module)
        }
    }

    useEffect(() => {
        if (AcademyList?.data?.data?.length === 1) {
            // first signup redirect to page
            if (AcademyList.data.data[0]['user_academies'] === null) {
                setSelectedAcademy(AcademyList.data.data[0], 'student/first')
            }

            const myUserAcademies = AcademyList.data.data[0]['user_academies']

            if (!!myUserAcademies?.student && (!!!myUserAcademies?.teacher && !!!myUserAcademies.expert)) {
                setSelectedAcademy(AcademyList.data.data[0], 'student')
            }

            if (!!myUserAcademies?.teacher && (!!!myUserAcademies?.student && !!!myUserAcademies.expert)) {
                setSelectedAcademy(AcademyList.data.data[0], 'teacher')
            }
        }
    }, [AcademyList])

    const columns = [
        {
            title: 'شناسه',
            dataIndex: 'id',
            key: 'id',
            render: (text, record) => {
                return <Link to={sprintf(URLS.admin.survey.edit, {id: record.id})}>{toFaNumber(text)}</Link>
            }

        },
        {
            title: 'مرکز آموزشی',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => {
                return text
            }

        },
        {
            title: '',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => {
                let actions = []
                if (record?.user_academies?.student) {

                    actions.push(<>
                        <Button type={'link'} size={'small'} onClick={() => setSelectedAcademy(record, 'student')}>
                            بخش دانش آموزان
                        </Button>
                    </>)
                }
                if (record?.user_academies?.teacher) {

                    actions.push(<>
                        <Button type={'link'} size={'small'} onClick={() => setSelectedAcademy(record, 'teacher')}>
                            بخش اساتید
                        </Button>
                    </>)
                }

                if (record?.user_academies?.expert) {

                    actions.push(<>
                        <Button type={'link'} size={'small'} onClick={() => setSelectedAcademy(record, 'admin')}>
                            بخش مدیریت
                        </Button>

                    </>)
                    actions.push(<>
                        <Button type={'link'} size={'small'} onClick={() => setSelectedAcademy(record, 'old-admin')}>
                            بخش مدیریت ( سامانه قدیم)
                        </Button>

                    </>)
                }


                if (
                    !record?.user_academies?.student &&
                    !record?.user_academies?.teacher &&
                    !record?.user_academies?.expert
                ) {

                    actions.push(<>
                        <Button type={'link'} size={'small'}
                                onClick={() => setSelectedAcademy(record, 'student/first')}>
                            ثبت‌نام و تکمیل اطلاعات
                        </Button>
                    </>)
                }
                return <div className={'flex flex-wrap gap-2'}>{actions}</div>
            }

        },
    ];

    if (AcademyList?.data?.data?.length > 5) {
        return (<>
            <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
                <div className=" w-full space-y-8">
                    <div className="text-center">
                        <h2 className="mt-6 text-3xl font-extrabold  ">
                            خوش آمدید
                        </h2>
                        <p className="mt-2 text-sm text-gray-600">
                            برای ورود نقش خود را انتخاب کنید
                        </p>
                    </div>
                    <TableSearch apiFn={useApiSearchAcademies}
                                 searchInput={true}

                                 columns={columns}></TableSearch>
                </div>
            </div>
        </>)
    }


    return (
        <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full space-y-8">

                {isPending && <div className={'text-center'}><Spin spinning={true} size={'large'}/></div>}
                {AcademyList?.data?.data?.length > 0 &&
                    <>
                        <div className="text-center">
                            <h2 className="mt-6 text-3xl font-extrabold ">
                                خوش آمدید
                            </h2>
                            <p className="mt-2 text-sm ">
                                برای ورود،‌ مرکز آموزشی و نقش خود را انتخاب کنید
                            </p>
                        </div>

                        <div className="mt-8 space-y-4">

                            {isPending && <Card loading={isPending}/>}

                            <RenderIf condition={isSuccess}>
                                {AcademyList?.data?.data?.map((academy, index) => (

                                        <GatewayAcademyCardSection academy={academy}
                                                                   key={'select-page-academy2-' + index + '-' + academy.id}
                                                                   onSelect={setSelectedAcademy}
                                        />


                                    )
                                )}
                            </RenderIf>

                        </div>
                        <Divider type={'divider'}/>
                    </>
                }


                {isPending ? <></> : <div className="text-center text-blue-600">

                    <Link to={URLS.auth.logout}>خروج از حساب کاربری</Link>
                </div>}

            </div>
        </div>
    )
}


export default GatewaySelectorPage;